import React from 'react';
import { mockData } from '../data/mock';

const StatsSection = () => {
  return (
    <section className="bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        {/* Main Content Layout - Text Left, Images Right */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">
          {/* Left Side - Text Content */}
          <div className="order-2 lg:order-1">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-light text-stone-800 leading-tight mb-8 title-font">
              The dream of<br />
              owning a home<br />
              in Uganda is now<br />
              within reach!
            </h2>
            <p className="text-stone-600 text-lg tracking-wide">
              At Nyinimu Properties, inspired by the Luganda word for "owner of the home," we're making that dream a reality for everyone. Whether you're a DJ, MC, Salon Operator, or Bouncer, we understand your unique income patterns.
            </p>
          </div>

          {/* Right Side - Property Images */}
          <div className="order-1 lg:order-2">
            <div className="grid grid-cols-1 gap-6">
              <div className="relative group overflow-hidden">
                <img
                  src="https://ik.imagekit.io/hqhiltiie/Nyinimu/done%20house/e868422d41c58b6b0bd8ee693e691380.jpg?updatedAt=1760196217960"
                  alt="Modern Apartment Building"
                  className="w-full h-64 object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="relative group overflow-hidden">
                <img
                  src="https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
                  alt="Luxury Interior"
                  className="w-full h-64 object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Stats Grid - Full Width */}
        <div className="w-full bg-stone-50 py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
              {mockData.stats.map((stat, index) => (
                <div key={index} className="text-center relative">
                  {/* Large faded background number */}
                  <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                    <span className="text-8xl md:text-9xl lg:text-[12rem] xl:text-[14rem] font-thin text-stone-200 opacity-30 leading-none">
                      {stat.number}
                    </span>
                  </div>
                  
                  {/* Foreground content */}
                  <div className="relative z-10 pt-8 pb-4">
                    <span className="text-4xl md:text-5xl lg:text-6xl font-light text-stone-800 block mb-8">
                      {stat.number}
                    </span>
                    <h3 className="text-xs md:text-sm font-medium text-stone-700 uppercase tracking-[0.2em]">
                      {stat.label}
                    </h3>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;